import { get, split } from "lodash";

export default (phone: string): string => {
  return get(split(phone, ";"), "0", "");
};
